const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_COMMON_AM10010: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10010',
						hint: [],
					},				
				},
			},
			ZZ2: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_SYUGUANG_PB00101: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10020',
						hint: [],
						ZZ_SYUGUANG_PB00101: { name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'] },
					},
					ZZ_SYUGUANG_PB00102: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10021',
						hint: [],
						ZZ_SYUGUANG_PB00102: { name: ['薪資報表', 'Salary report', '薪资报表'] }, 
					},					
				},
			},
			ZZ3: {
				name: ['薪資袋設定', '薪資袋設定', '薪資袋設定'],
				children: {
					ZZ_TAIWANGIVEN_PB40110: {
						name: ['(客製)獎金公式科目設定', '(客製)獎金公式科目設定', '(客製)獎金公式科目設定'],
						url: '/zz_taiwangiven_pb40110',
						hint: [],
					},
				},
			},

		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};